export const HttpMethods = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const APIContexts = {
  ASSET_HISTORY: 'AssetHistory',
  ASSET_VERSION: 'AssetVersion',
  BUSINESS_RULE: 'BusinessRuleV2',
  CHANNEL: 'Channel',
  COMMERCIAL: 'Commercial',
  EXPORT: 'Export',
  INTERSTITIAL: 'Interstitial',
  PLAYLIST: 'Playlist',
  PROGRAMLIBRARY: 'ProgramLibrary',
  REPORTING: 'Reporting',
  RIGHT: 'Right',
  SCHEDULE: 'Schedule',
  SEASON: 'Season',
  TITLE: 'Title',
  TITLE_EXCLUSION: 'TitleExclusion',
  TITLE_GROUP: 'TitleGroup',
  USER: 'User',
};
